import { ScheduleGroupItem, ScheduleGroup } from "domain-entities";
import { v4 } from "uuid";

export function getRemainingItems<T>(
	originals: (T & { id: string })[],
	originalIdKey: "userId" | "resourceId",
	scheduleGroupItems: ScheduleGroupItem[]
) {
	const scheduleGroupItemIds = scheduleGroupItems.map(
		(scheduleGroupItem) => scheduleGroupItem[originalIdKey]
	);

	return originals.reduce<ScheduleGroupItem[]>((result, original) => {
		if (!scheduleGroupItemIds.includes(original.id)) {
			const id = v4();
			result.push({
				id,
				[originalIdKey]: original.id,
			});
		}

		return result;
	}, []);
}

/**
 * Because react-sortablejs adds fields like `selected` or `chosen`
 * to the groups and items, we have to clean them up.
 */
export function getCleanedScheduleGroups(
	dirtyScheduleGroups: ScheduleGroup[] & object
) {
	return dirtyScheduleGroups.reduce<ScheduleGroup[]>(
		(cleanedGroups, dirtyScheduleGroup) => {
			const scheduleGroupItems = dirtyScheduleGroup.items.reduce<
				ScheduleGroupItem[]
			>((cleanedItems, dirtyScheduleGroupItem) => {
				const scheduleGroupItem: ScheduleGroupItem = {
					id: dirtyScheduleGroupItem.id,
				};

				if (dirtyScheduleGroupItem.userId) {
					scheduleGroupItem.userId = dirtyScheduleGroupItem.userId;
				} else if (dirtyScheduleGroupItem.resourceId) {
					scheduleGroupItem.resourceId = dirtyScheduleGroupItem.resourceId;
				}

				cleanedItems.push(scheduleGroupItem);

				return cleanedItems;
			}, []);

			cleanedGroups.push({
				id: dirtyScheduleGroup.id,
				name: dirtyScheduleGroup.name,
				items: scheduleGroupItems,
			});

			return cleanedGroups;
		},
		[]
	);
}
